// extracted by mini-css-extract-plugin
module.exports = {"container":"_1sGQAPMDBB4NqLUllDqfX7","answers":"_2rBHa4yw00ufO3FoKQIIO9","button":"_1m_xq59fkUtsrvwZRajua4","answer":"_1UuilqRgCaepLDmEuZDwF5"};